// @flow

import invertedColors from './invertedColors';
import colorPreferences, { type ColorPreference } from './colorPreferences';

export default invertedColors;

export { colorPreferences };
export type { ColorPreference };
